import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// // import registerServiceWorker from './registerServiceWorker';
import ApolloClient, { createNetworkInterface } from 'apollo-client'
// import { createNetworkInterface } from 'apollo-upload-client'
import { ApolloProvider, browserHistory } from 'react-apollo'
import { BrowserRouter as Router } from 'react-router-dom'
import { LocaleProvider } from 'antd'
import RouterApp from './Router'
import enUS from 'antd/lib/locale-provider/en_US'
import 'antd/dist/antd.css'


    const client = new ApolloClient ({
        networkInterface: createNetworkInterface({
            uri: 'https://api.followme.phuket.run/graphql' //process.env.REACT_APP_GRAPHQL_URI,// 'http://192.168.1.12:19000/graphql'// 'http://localhost:19000/graphql', //`${config.get('graphql.uri')}`
        })
    })

 ReactDOM.render(
    <LocaleProvider locale={enUS}>
        <ApolloProvider client={client}>
            <Router history={ browserHistory }>
                <RouterApp />
            </Router>
        </ApolloProvider>
    </LocaleProvider>
    , document.getElementById('root')
); 
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js